const { __, __x, __nx, __N } = JIX.Gettext;

export default {
    statusOnline: () =>
        __('Vil gerne kontaktes'),
    statusOffline: () =>
        __('Vil ikke kontaktes'),
};
